import React from "react";
import SearchJob from "../../images/hireDeveloper/searchJob.jpg";
import BestJob from "../../images/hireDeveloper/bestJob.jpg";
import paidOn from "../../images/hireDeveloper/paidOn.jpg";
import { Link } from "react-router-dom";

const RemoteJob = () => {
  return (
    <>
      <section className="remoteJobSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div
                className="information"
                data-aos="zoom-in"
                style={{ backgroundImage: `url("${BestJob}")` }}
              >
                <div className="row justify-content-end">
                  <div className="col-md-6 col-sm-9" data-aos="slide-right">
                    <h4>
                      Discover <span>The Best</span> Remote Job Around The Globe
                    </h4>
                    <p>
                      With Hire Remote Team you get to explore the best remote
                      jobs with top companies around the globe in countries like
                      the US, UK, Canada, and many more.
                    </p>
                    <Link to="/GetHireDeveloper" className="btn">
                      <span>Apply For Remote Jobs</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="information"
                data-aos="zoom-in"
                style={{ backgroundImage: `url("${SearchJob}")` }}
              >
                <div className="row">
                  <div className="col-md-6 col-sm-9" data-aos="slide-right">
                    <h4>
                      Search Jobs For <span>20+ Skills</span> In Senioritis
                    </h4>
                    <p>
                      Apply for a job requiring skills like React, Node, Python,
                      Angular, Swift, React, Native, Android, Java, and many
                      more.
                    </p>
                    <Link to="/GetHireDeveloper" className="btn">
                      <span>Apply For Remote Jobs</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className="information"
                data-aos="zoom-in"
                style={{ backgroundImage: `url("${paidOn}")` }}
              >
                <div className="row justify-content-end">
                  <div className="col-md-6 col-sm-9" data-aos="slide-right">
                    <h4>
                      Get<span> Paid On</span> The Best Pay Scale Around The
                      Globe
                    </h4>
                    <p>
                      Work remotely with global companies and get paid in
                      foreign currencies.
                    </p>
                    <Link to="/GetHireDeveloper" className="btn">
                      <span>Apply For Remote Jobs</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RemoteJob;
